import {FaCheckCircle, FaParking} from "react-icons/fa";
import React from "react";
import {ParkingFeeModel} from "../parkingfee/ParkingFeeModel";
import {createOrUpdateParkingFee} from "../../service/JobService";
import {CheckListModel} from "./CheckListModel";


export const CheckList = (props) => {
    const {job, fieldSupervisorMap, fieldWorkerMap} = props;
    const [show, setShow] = React.useState(false);
    const [message, setMessage] = React.useState("")


    const handleClose = (e) => {
        if (e) {
            e.stopPropagation()
        }
        setMessage("")
        setShow(false)
    }

    return (
        <>
            <FaCheckCircle style={{marginLeft: "10px", cursor: "pointer",color: job.score>0 ? "green" : "grey"}}
                       size={22}
                       title={"Supervisor Checked"}
                       onClick={(e) => {
                           e.stopPropagation()
                           setShow(true)
                       }}
            /> {show &&
            <CheckListModel
                show={show}
                job={job}
                fieldSupervisorMap={fieldSupervisorMap}
                fieldWorkerMap={fieldWorkerMap}
                handleClose={handleClose}
                message={message}
                setMessage={setMessage}
            />}
        </>
    )
}
